// src/loggingService.js

import { db } from './firebase';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';

/**
 * Registra un'azione dell'utente nella collezione 'logs' di Firestore.
 * @param {object} user - L'oggetto utente (da userProfile) che compie l'azione.
 * @param {string} action - Una stringa descrittiva dell'azione (es. "ha creato la stanza 'Stanza A'").
 * @param {object} [details={}] - Un oggetto opzionale con dettagli aggiuntivi.
 */
export const logAction = async (user, action, details = {}) => {
  if (!user || !user.name || !user.centerId) { // <-- MODIFICA QUI
    console.error("Tentativo di log senza un utente valido o senza centerId."); // <-- MODIFICA QUI
    return;
}

  try {
    await addDoc(collection(db, 'centers', user.centerId, 'logs'), { // <-- MODIFICA QUI
      timestamp: serverTimestamp(), // Firestore imposterà data e ora del server
      userId: user.uid,
      userName: user.name,
      action: action,
      details: details,
      centerId: user.centerId,
    });
  } catch (error) {
    console.error("Errore durante la scrittura del log:", error);
  }
};